import React from 'react';
import { Check, Checks, Clock } from '@phosphor-icons/react';

const ReadReceipts = ({ message, isSender }) => {
  // Only show for sender's messages
  if (!isSender) return null;

  // Show clock icon for pending / optimistic messages
  if (message.pending || message.status === 'pending') {
    return (
      <span className="inline-flex items-center ml-1" title="Sending...">
        <Clock size={13} weight="bold" className="text-gray-400 opacity-75" />
      </span>
    );
  }

  // Handle delivered/read status
  const delivered = message.delivered !== undefined ? message.delivered : true;
  const isRead = Boolean(
    message.read === true ||
    (message.readBy && Object.keys(message.readBy).some(id => id !== (message.sender_id || message.senderId))) ||
    (message.read_by && Object.keys(message.read_by).some(id => id !== (message.sender_id || message.senderId)))
  );

  return (
    <span className="inline-flex items-center ml-1">
      {!delivered && (
        // Single tick - Sent (not yet delivered)
        <Check size={16} weight="bold" className="text-gray-400" />
      )}
      
      {delivered && !isRead && (
        // Double tick - Delivered (not yet read)
        <Checks size={16} weight="bold" className="text-gray-400" />
      )}
      
      {delivered && isRead && (
        // Double tick Blue - Read
        <Checks size={16} weight="bold" className="text-blue-500" />
      )}
    </span>
  );
};

export default ReadReceipts;
